export const sexualRelationshipTypePopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Is a miracle mentioned? How are the miracle framed?
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Clarifies whether a supernatural claim is presented as belief, suggestion,
      or fact, which is crucial for assessing neutrality and potential bias.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        <strong>None:</strong> The text describes a historical battle but makes
        no mention of any supernatural events.
      </div>
      <div style={{ marginTop: 8 }}>
        <strong>Implied:</strong> The healing was seen by many as a sign from
        God, though not everyone agreed on its meaning.
      </div>
      <div style={{ marginTop: 8 }}>
        <strong>Asserted_as_fact:</strong> Jesus walked on water to reach his
        disciples during a storm, demonstrating his divine power.
      </div>
    </div>
  </div>
);

export const characterAgePopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Are the references explicit (named) or only hinted at?
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Clarifies whether a religion is directly named or only alluded to, which
      impacts how clearly the content aligns with or critiques specific faiths.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        <strong>None:</strong> The text discusses the rise of urban centers
        without referencing any belief systems.
      </div>
      <div style={{ marginTop: 8 }}>
        <strong>Implicit:</strong> Worshippers gather weekly to hear teachings
        and sing hymns.
      </div>
      <div style={{ marginTop: 8 }}>
        <strong>Explicit:</strong> Christians gather every Sunday for church
        services led by a pastor.
      </div>
    </div>
  </div>
);

export const euphemismsListPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Are claims attributed to believers, or stated by the narrator?
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Identifies whether religious claims are presented as beliefs held by
      others or stated as facts, which helps detect bias, endorsement, or
      neutrality in narration.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <strong>Attributed:</strong> Hindus believe that the soul is reborn
      through cycles of reincarnation.
      <br />
      <strong>Unattributed:</strong> The soul is reborn after death in a
      continuous cycle.
      <br />
      <strong>Mixed:</strong> Many Buddhists view suffering as central to life,
      but the text also states that all life is suffering.
    </div>
  </div>
);

export const suggestivePhrasesListPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Model’s 0‑1 confidence in the tone label.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Low confidence warns reviewers the label may be shaky.
    </div>
  </div>
);

export const powerImbalancePresentPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Detects adult-minor or authority dynamic.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Detecting power_imbalance_present is essential for identifying content
      where consent, coercion, or grooming risk may be elevated, even if the
      scene appears subtle or non-explicit — especially when combined with other
      signals like tone, physical_contact_implied, or suggestive_phrases_found.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        True: "She waited after class while the teacher closed the door behind
        them, his tone shifting to something more personal."
      </div>
      <div style={{ marginTop: 8 }}>
        False: "The two teens walked home together, talking about their shared
        science project."
      </div>
    </div>
  </div>
);

export const tonePopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      General style of writing: neutral, praising, critical, or storytelling.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Tone provides an immediate signal of intent—whether the passage aims to
      inform, praise, criticize, or tell a story—helping reviewers quickly
      identify potential bias or persuasion.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        Academic: Scholars have long studied the influence of early Islamic
        architecture on medieval Europe.
      </div>
      <div style={{ marginTop: 8 }}>
        Devotional: Praise be to the Lord, whose mercy and wisdom guide our
        lives each day.
      </div>
      <div style={{ marginTop: 8 }}>
        Polemical: These outdated beliefs have no place in a modern society
        built on reason and progress.
      </div>
      <div style={{ marginTop: 8 }}>
        Narrative: As the sun rose over the temple, the priests prepared for the
        sacred ceremony.
      </div>
    </div>
  </div>
);

export const excessiveFocusOnBodyDescriptionPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Detects whether the text lingers on or over-describes a character’s
      physical body, especially in a way that draws unnecessary, sensual, or
      disproportionate attention to appearance or anatomy.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      The excessive_focus_on_body_description field helps the pipeline identify
      objectifying or suggestive narration, especially when subtle or
      non-explicit, flagging content that may appear inappropriate when paired
      with other signals like character_age, tone, or nudity_type.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        "Her dress clung to her curves, outlining the dip of her waist and the
        rise of her chest. Every step revealed the smoothness of her legs, the
        shimmer of her skin catching the light."
        <br />→ Output: true
      </div>
      <div style={{ marginTop: 8 }}>
        "She was tall and athletic, her long hair tied back as she stepped onto
        the court."
        <br />→ Output: false
      </div>
    </div>
  </div>
);

export const languageOfSecrecyOrConcealmentPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Flags whether characters use language that suggests hiding, secrecy, or
      concealment, such as "don’t tell anyone," "just between us," or "no one
      can find out."
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      The language_of_secrecy_or_concealment field helps identify situations
      where characters are encouraged to hide interactions, a common red flag in
      grooming or exploitative dynamics — especially when combined with
      power_imbalance_present, tone, or character_age.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        "No one can know about this, okay? Promise me you won’t say anything to
        your parents."
        <br />→ Output: true
      </div>
      <div style={{ marginTop: 8 }}>
        "She told her mom everything that happened that day — even the awkward
        parts."
        <br />→ Output: false
      </div>
    </div>
  </div>
);

export const roleplayOrFantasyContextPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Identifies whether the scene is framed as a dream, fantasy, daydream,
      internal imagination, or roleplay scenario, rather than occurring in
      direct narrative reality.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      The roleplay_or_fantasy_context field helps the pipeline distinguish
      between real interactions and imagined ones, which is crucial for
      assessing intent, severity, and risk.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        "In her head, she imagined what it would feel like to kiss him — the way
        he might hold her hand, say her name softly. But then the bell rang, and
        the fantasy broke."
        <br />→ Output: true
      </div>
      <div style={{ marginTop: 8 }}>
        "He kissed her on the forehead before heading to class, their fingers
        still loosely intertwined."
        <br />→ Output: false
      </div>
    </div>
  </div>
);

export const voilenceOverlapPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Flags whether aggression, coercion, force, or violence is present within
      or alongside sexual or suggestive content.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      The violence_overlap field helps identify scenes where sexual or romantic
      content is paired with aggression or coercion, signaling higher risk for
      abuse, trauma, or grooming — making it essential for safety screening when
      used with fields like physical_contact_implied, power_imbalance_present,
      or character_age.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        "He grabbed her wrist as she tried to back away, whispering that she
        knew she wanted this."
        <br />→ Output: true
      </div>
      <div style={{ marginTop: 8 }}>
        "They sat close together, laughing as their hands brushed, both clearly
        nervous but happy."
        <br />→ Output: false
      </div>
    </div>
  </div>
);

export const nudityDetectedPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Detects if nudity to any extent is detected, and determines if it is
      non-sexual or sexual. If unsure, but clear nudity exists then chooses
      "general".
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      The nudity_detected field captures whether nudity exists at all, and how
      it’s framed, helping the system distinguish between benign and risky
      nudity even when visual details (handled by nudity_type) are minimal or
      unclear — supporting better severity assessment and content filtering.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        "She stepped out of the shower and reached for the towel, shivering as
        the cold air hit her skin."
        <br />→ Output: general
      </div>
      <div style={{ marginTop: 8 }}>
        "The patient lay naked on the examination table as the doctor conducted
        the routine checkup."
        <br />→ Output: non-sexual
      </div>
      <div style={{ marginTop: 8 }}>
        "She let the dress fall to the floor, his gaze tracing every inch of her
        bare skin as she moved toward him."
        <br />→ Output: sexual
      </div>
    </div>
  </div>
);

export const nudityExtentPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Classifies the extent to which nudity is detected in the text, from no
      implication to explicit references.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      The nudity_implied field helps the pipeline recognize non-visual,
      suggestive cues that imply nudity without directly stating it, which is
      essential for detecting borderline or literary nudity often found in
      classic, poetic, or emotionally nuanced texts.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        "She stepped behind the curtain and let the robe slip from her
        shoulders, the fabric whispering to the floor."
        <br />→ Output: subtly implied
      </div>
      <div style={{ marginTop: 8 }}>
        "He stood naked in front of the mirror, studying the marks on his
        chest."
        <br />→ Output: explicit
      </div>
    </div>
  </div>
);

export const nudityTypePopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Categorizes the degree and style of nudity or body exposure described in
      the text — whether partial, implied through clothing, or explicitly
      stated.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      The nudity_type field allows the system to distinguish between clinical,
      accidental, or stylized exposure and graphic or intentional nudity,
      providing critical nuance for evaluating severity, intent, and
      appropriateness — especially when paired with fields like tone,
      character_age, or physical_contact_implied.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        "She pulled the towel tighter around her chest as he turned away, giving
        her a moment of privacy."
        <br />→ Output: partial, top
      </div>
      <div style={{ marginTop: 8 }}>
        "His shirt clung to his body, soaked from the rain, outlining every
        contour."
        <br />→ Output: clingy, revealing
      </div>
    </div>
  </div>
);

export const sexualActsDetectedPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Identifies and categorizes specific sexual acts described or implied in
      the content, whether explicit or euphemistic.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Allows the pipeline to distinguish between different levels of sexual
      activity, which is critical for assigning severity.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        "He pulled her close and kissed her deeply, their breath quickening as
        the world seemed to blur around them."
        <br />→ Output: passionate kissing
      </div>
      <div style={{ marginTop: 8 }}>
        "He kissed her again, slower this time, fingers fumbling with the
        buttons of her shirt. She didn’t stop him."
        <br />→ Output: kissing, undressing, intimate touching
      </div>
    </div>
  </div>
);

export const religiousSlangListPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      List of the slang terms detected.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Lists the exact informal religious terms detected, helping reviewers
      assess whether casual expressions of faith or celebration influence the
      passage's tone or alignment—informing tone, disrespect-towards-religion?,
      and final-bias-stance-by-religion.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        The crowd cheered and someone shouted, “Hallelujah, we made it through
        finals!”
        <br />→ Output: ["Hallelujah"]
      </div>
    </div>
  </div>
);

export const historicSlurListPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      List of historic slurs or pejorative terms detected in the paragraph.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Surfaces the exact outdated or derogatory terms detected, allowing
      reviewers to quickly assess whether the language reflects colonial,
      religious, or ethnic bias—supporting judgments in tone,
      disrespect-towards-religion?, and final-bias-stance-by-religion.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        During the medieval campaigns, knights claimed they were defending
        Christendom from infidels and heathen armies.
        <br />→ Output: ["infidels", "heathen"]
      </div>
    </div>
  </div>
);

export const historicSlursFoundPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Does the paragraph include outdated or derogatory terms with religious or
      ethnic implications?
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Detects outdated or derogatory terms once used to describe non-Christian
      or non-European groups, which can reflect colonialist bias or religious
      superiority. This helps inform tone, final-bias-stance-by-religion, and
      disrespect-towards-religion?.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        <strong>True:</strong> The missionaries believed it was their duty to
        civilize the heathen tribes they encountered in the New World.
      </div>
      <div style={{ marginTop: 8 }}>
        <strong>False:</strong> The missionaries aimed to teach their language
        and religion to the indigenous communities they encountered.
      </div>
    </div>
  </div>
);

export const metaphoricReligiousTermFoundPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Is a religious term being used metaphorically rather than literally?
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Flags figurative uses of religious terms that may trivialize persecution,
      faith, or historical events—supporting analysis in tone,
      final-bias-stance-by-religion, and disrespect-towards-religion?.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        <strong>True:</strong> The senator called the investigation a political
        witch-hunt meant to silence dissent.
      </div>
      <div style={{ marginTop: 8 }}>
        <strong>False:</strong> The book details how accused women were put on
        trial during the Salem witch hunts of the 1600s.
      </div>
    </div>
  </div>
);

export const metaphoricReligiousTermListPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      List of metaphoric or symbolic religious terms detected.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Identifies specific metaphorical religious terms used in non-religious
      contexts, helping reviewers catch language that may unintentionally invoke
      historical conflict, persecution, or cultural bias—supporting fields like
      tone, final-bias-stance-by-religion, and disrespect-towards-religion.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        Example: The CEO launched a crusade against inefficiency, promising to
        root out “wasteful practices” across departments.
        <br />→ Output: ["witch-hunt","crusade"]
      </div>
    </div>
  </div>
);

export const disrespectTriggerListPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      List of phrases or patterns that triggered the disrespect flag.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Shows exactly which mocking or disrespectful phrases triggered the flag,
      allowing reviewers to assess how overt or subtle the mockery is—supporting
      escalation decisions and informing disrespect-towards-religion and
      final-bias-stance-by-religion.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        Example 1: People still worship a magic beard man in the sky and expect
        miracles to fix their problems.
      </div>
      <div style={{ marginTop: 8 }}>
        Example 2: Believing in an imaginary god won’t help you pass a math
        test.
      </div>
      <div style={{ marginTop: 8 }}>
        → Output: ["magic beard man", "imaginary god"]
      </div>
    </div>
  </div>
);

export const disrespectedReligionsPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      List of religions that are mocked or belittled in the paragraph.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Identifies which faiths are being targeted; important for fairness and
      escalation.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        Example Christianity: People still worship a magic beard man in the sky
        and expect miracles to fix their problems.
      </div>
      <div style={{ marginTop: 8 }}>
        Example 2 Mormonism: Claiming that a man found golden plates in the
        woods and started a religion is just laughable.
      </div>
      <div style={{ marginTop: 8 }}>
        → Output: ["christianity", "mormonism"]
      </div>
    </div>
  </div>
);

export const comparisonFrameDetectedPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Does the paragraph compare two or more religions or belief systems?
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Detects when religions are directly compared, which can introduce
      imbalance or favoritism—supporting deeper bias analysis in
      final-bias-stance-by-religion and tone.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        <strong>True:</strong> Unlike Christianity, which focuses on salvation
        through faith, Buddhism emphasizes personal enlightenment through
        meditation.
      </div>
      <div style={{ marginTop: 8 }}>
        <strong>False:</strong> Buddhism emphasizes personal enlightenment
        through meditation and mindfulness.
      </div>
    </div>
  </div>
);

export const comparedReligionsPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      List of religions mentioned in comparative framing.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Extracts the specific religions being compared so the system can assess
      balance or favoritism in framing—supporting fairness checks and enriching
      final-bias-stance-by-religion.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        Example: Christianity views the Bible as the final revelation, while
        Mormonism adds the Book of Mormon as another sacred text.
        <br />→ Output: ["christianity","mormonism"]
      </div>
    </div>
  </div>
);

export const doctrineClaimTypePopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Is a specific belief or doctrine being asserted, challenged, or described?
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Clarifies how the text positions religious claims—whether as fact, belief,
      or critique—helping reviewers judge neutrality and supporting fields like
      framing-strength and final-bias-stance-by-religion.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        None: The chapter focuses on trade routes and economic systems of early
        empires.
      </div>
      <div style={{ marginTop: 8 }}>
        Asserted: The Torah was divinely revealed to Moses on Mount Sinai.
      </div>
      <div style={{ marginTop: 8 }}>
        Challenged: Some scholars argue that the resurrection story was a later
        invention to inspire followers.
      </div>
      <div style={{ marginTop: 8 }}>
        Described: Muslims believe that Muhammad received the final revelation
        from God through the angel Gabriel.
      </div>
    </div>
  </div>
);

export const framingStrengthPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      How confidently is the paragraph asserting its religious claim or
      narrative?
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Indicates how strongly a belief or claim is being presented, which can
      suggest endorsement or bias—especially when combined with fields like
      doctrine-claim-type, tone, or final-bias-stance-by-religion.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        Weak: Some followers believe that divine intervention played a role in
        the outcome.
      </div>
      <div style={{ marginTop: 8 }}>
        Moderate: Many religious texts describe events interpreted as signs from
        a higher power.
      </div>
      <div style={{ marginTop: 8 }}>
        Strong: It is a proven truth that divine power guided the actions of the
        faithful throughout history.
      </div>
    </div>
  </div>
);

export const draftStanceByReligionPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Model’s first guess of attitude toward each religion.
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Summarizes the model’s initial impression of bias toward each mentioned
      religion by intaking all prior fields—especially tone, who-says-it?, and
      doctrine-claim-type, which carry the most weight early on. This field
      provides a fast, structured assessment of stance before broader context or
      reversals are considered, helping catch potentially problematic content
      quickly and flagging disagreements when compared to
      final-bias-stance-by-religion.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        Example: Christianity spread rapidly through the Roman Empire, while
        Mormonism was based on the questionable claim that golden plates were
        discovered in upstate New York.
        <br />→ Output:{' '}
        <code>
          {JSON.stringify(
            {
              christianity: 'neutral-1',
              mormonism: 'unfavorable-4',
            },
            null,
            2,
          )}
        </code>
      </div>
    </div>
  </div>
);

export const disrespectTowardsReligionPopoverContent = (
  <div
    style={{
      maxWidth: 350,
      background: '#f5f5f5',
      padding: 16,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}
  >
    <div style={{ marginBottom: 16 }}>
      <strong>Description:</strong>
      <br />
      Does the passage mock, ridicule, or belittle a religion, its beliefs, or
      its followers?
    </div>
    <div style={{ marginBottom: 16 }}>
      <strong>Why This Matters:</strong>
      <br />
      Captures ridicule or contempt toward religious beliefs that may not be
      detected through tone or attribution alone, supporting accurate judgments
      in final-bias-stance-by-religion and flagging content for human review
      when necessary.
    </div>
    <div>
      <strong>Example Content:</strong>
      <br />
      <div>
        <strong>True:</strong> Some people still waste their time praying to
        invisible sky beings instead of doing something useful.
      </div>
      <div style={{ marginTop: 8 }}>
        <strong>False:</strong> Many communities gather weekly to pray and
        reflect, following long-standing religious traditions.
      </div>
    </div>
  </div>
);
